import SiteLayout from '@/components/feature/SiteLayout';
import PageHero from '@/components/feature/PageHero';
import SectionHeading from '@/components/feature/SectionHeading';
import CtaBanner from '@/components/feature/CtaBanner';
import CategoryGrid from '@/pages/products/components/CategoryGrid';
import FeaturedProducts from '@/pages/products/components/FeaturedProducts';

const rangeHighlights = [
  { id: 'total', value: '150+', label: 'Herbal Formulations' },
  { id: 'categories', value: '10', label: 'Product Categories' },
  { id: 'gmp', value: 'GMP', label: 'Certified Manufacturing' },
  { id: 'states', value: '18+', label: 'States Served' },
];

export default function ProductsPage() {
  return (
    <SiteLayout>
      <PageHero
        eyebrow="Our Products"
        title="150+ GMP Certified Ayurvedic Products"
        description="Capsules, tablets, syrups, kashayam, lehyam, oils, ointments, churanam, powders and self care — manufactured direct from our unit in Madurai."
        crumbs={[{ label: 'Home', to: '/' }, { label: 'Products' }]}
        image="https://readdy.ai/api/search-image?query=A%20collection%20of%20Ayurvedic%20herbal%20medicine%20products%20including%20amber%20glass%20bottles%2C%20capsule%20bottles%2C%20labeled%20jars%20and%20herbal%20oils%20arranged%20elegantly%20on%20a%20clean%20surface%20with%20fresh%20green%20herbs%20and%20botanical%20leaves%20around%2C%20bright%20airy%20natural%20lighting%2C%20editorial%20product%20photography%20high%20detail&width=1600&height=900&seq=products-hero-range-01&orientation=landscape"
      />

      <section className="w-full bg-background-50 border-b border-background-200 py-8 md:py-10">
        <div className="w-full px-4 md:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {rangeHighlights.map((item) => (
              <div
                key={item.id}
                className="rounded-lg border border-background-200 bg-background-100/60 p-4 text-center"
              >
                <p className="font-heading text-2xl md:text-3xl font-semibold text-primary-700">{item.value}</p>
                <p className="mt-1 text-xs md:text-sm text-foreground-600">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="w-full bg-background-50 pt-14 md:pt-20">
        <div className="w-full px-4 md:px-8">
          <SectionHeading
            eyebrow="Browse By Category"
            title="Explore Our Product Range"
            description="From convenient capsules to traditional lehyam, every formulation is prepared with pure herbs and time-honoured Ayurvedic wisdom."
          />
        </div>
      </section>
      <CategoryGrid />

      <FeaturedProducts />

      <CtaBanner
        eyebrow="Bulk & Wholesale"
        title="Need Manufacturer-Direct Pricing?"
        description="We supply pharmacies, clinics, hospitals and distributors across India. Share your requirement and get competitive bulk pricing."
        primary={{ label: 'Send an Enquiry', to: '/contact', icon: 'ri-send-plane-fill' }}
        secondary={{ label: 'Become a Distributor', to: '/#distributor-apply', icon: 'ri-hand-heart-line' }}
      />
    </SiteLayout>
  );
}